import { render, staticRenderFns } from "./PublicationSingleMore.vue?vue&type=template&id=5b7fca49&"
import script from "./PublicationSingleMore.vue?vue&type=script&lang=js&"
export * from "./PublicationSingleMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports